import { render } from "./WorkDataScreen.vue?vue&type=template&id=09681900&scoped=true&lang=html"
import script from "./WorkDataScreen.vue?vue&type=script&lang=js"
export * from "./WorkDataScreen.vue?vue&type=script&lang=js"

import "./WorkDataScreen.vue?vue&type=style&index=0&id=09681900&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/multiple_choice_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09681900"]])

export default __exports__